/**
 * Thong tin huy lich do BE tra ve. Moi truong co the null: lich chua huy, hoac lich huy
 * truoc khi BE bat dau ghi cac truong nay.
 */
export interface ICancelAudit {
  cancelReason?: string | null;
  /** BOOKING_ONLINE / SCHEDULE / WEB_STAFF / OPEN_API / UNKNOWN */
  cancelSource?: string | null;
  /** CUSTOMER / STAFF / SYSTEM */
  cancelledByType?: string | null;
  cancelledById?: number | null;
  cancelledByName?: string | null;
  /** Gio tiem, dinh dang giong start_time: MM/DD/YYYY hh:mm A */
  cancelledAt?: string | null;
}

const SOURCE_LABELS: Record<string, string> = {
  // Khach tu huy qua link Booking Online.
  BOOKING_ONLINE: 'Customer',
  SCHEDULE: 'Schedule',
  WEB_STAFF: 'Staff App',
  OPEN_API: 'Integration',
};

/** Nguon huy la hoac thieu deu hien "Unknown". */
export const getCancelSourceLabel = (source?: string | null) =>
  (source && SOURCE_LABELS[source]) || 'Unknown';

/** Ten nguoi huy, hoac rong khi khong xac dinh duoc. Huy qua tich hop thi ghi "System". */
export const formatCancelledBy = (audit: ICancelAudit) => {
  if (audit.cancelledByName) return audit.cancelledByName;
  if (audit.cancelledByType === 'SYSTEM') return 'System';
  return '';
};

/** Lich huy truoc khi BE ghi thong tin huy: khong co truong nao de hien. */
export const hasCancelAudit = (audit: ICancelAudit) => !!audit.cancelSource;
